import script from "./ProjectChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectChat.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout});
